import React, { useRef, useState } from 'react';

import { isEmpty } from 'lodash';

import NextStepsTable from 'pages/Teachers/Insights/components/NextStepsTable';
import StudentSummaryDialog from 'pages/Teachers/Insights/components/StudentSummaryDialog';
import StudentWorkPreview from 'pages/Teachers/Insights/components/StudentWorkPreview';
import { STUDENT_WORK_INTERCOM_TARGET } from 'pages/Teachers/Insights/constants';
import { colors } from 'theme/palette';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const MasteryLevelDetail = ({
  misconceptionName,
  students,
  nextSteps,
  exemplarUrls,
  refetchOverview,
  trackStudentWorkDialogClickEvent,
  trackNextStepCompleteEvent
}) => {
  const [summaryDialogIsOpen, setSummaryDialogIsOpen] = useState(false);
  const [studentName, setStudentName] = useState('');
  const [hoveredStudentWork, setHoveredStudentWork] = useState(null);

  const [workTagImages, setWorkTagImages] = useState([]);

  const hideTimeout = useRef(null);

  const showPreview = (workTagImageIds) => {
    clearTimeout(hideTimeout.current);
    setHoveredStudentWork(workTagImageIds);
  };

  const hidePreview = () => {
    hideTimeout.current = setTimeout(() => {
      setHoveredStudentWork(null);
    }, 200);
  };

  const handleStudentClickV2 = ({ name, workTagImageIds }) => {
    trackStudentWorkDialogClickEvent();

    setStudentName(name);
    setWorkTagImages(workTagImageIds);
    setSummaryDialogIsOpen(true);
  };

  const handleNextIconClick = () => {
    if (isEmpty(studentName)) return;

    const currentIndex = students.findIndex(
      (item) => item.name === studentName
    );
    const nextIndex = (currentIndex + 1) % students.length;

    const student = students[nextIndex];

    setWorkTagImages(student.work_tag_image_ids);

    setStudentName(student.name);
  };

  const handlePreviousIconClick = () => {
    if (isEmpty(studentName)) return;

    const currentIndex = students.findIndex(
      (item) => item.name === studentName
    );
    const previousIndex =
      (currentIndex - 1 + students.length) % students.length;

    const student = students[previousIndex];

    setWorkTagImages(student.work_tag_image_ids);

    setStudentName(student.name);
  };

  return (
    <div className={styles.details}>
      <div
        data-intercom-target={STUDENT_WORK_INTERCOM_TARGET}
        className={styles.students}
      >
        <div className={styles.studentsContainer}>
          {students.map(({ name, work_tag_image_ids, preview_url }) => (
            <div
              key={name}
              className={styles.studentNameContainer}
              onMouseEnter={() => {
                showPreview(work_tag_image_ids);
              }}
              onMouseLeave={() => {
                hidePreview();
              }}
              onClick={() => {
                handleStudentClickV2({
                  name: name,
                  workTagImageIds: work_tag_image_ids
                });
              }}
            >
              <Typography
                variant="B-TEXT-4"
                className={styles.studentName}
                color={colors.blue10}
              >
                {name}
              </Typography>
              {hoveredStudentWork === work_tag_image_ids && (
                <div
                  className={styles.previewWrapper}
                  onClick={() => {
                    handleStudentClickV2({
                      name: name,
                      workTagImageIds: work_tag_image_ids
                    });
                    setHoveredStudentWork(null);
                  }}
                >
                  <StudentWorkPreview name={name} workImageUrl={preview_url} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {!isEmpty(nextSteps) && (
        <div className={styles.nextSteps}>
          <NextStepsTable
            nextSteps={nextSteps}
            refetchOverview={refetchOverview}
            exemplarUrls={exemplarUrls}
            trackNextStepCompleteEvent={trackNextStepCompleteEvent}
          />
        </div>
      )}
      {summaryDialogIsOpen && (
        <StudentSummaryDialog
          misconceptionName={misconceptionName}
          studentName={studentName}
          workTagImageIds={workTagImages}
          allStudentsData={students}
          refetchOverview={refetchOverview}
          isSummaryDialogIsOpen={summaryDialogIsOpen}
          handleNextIconClick={handleNextIconClick}
          handlePreviousIconClick={handlePreviousIconClick}
          onClose={() => {
            setSummaryDialogIsOpen(false);
            setStudentName('');
          }}
        />
      )}
    </div>
  );
};

export default MasteryLevelDetail;
